export enum AuthScreenStep {
  PHONE_EMAIL_INPUT = 'phoneEmailInput',
  EVENT_ACCESS_CODE_INPUT = 'eventAccessCodeInput',
  FORGOT_PASSWORD = 'forgotPassword',
  CHANGE_FORGOTTEN_PASSWORD = 'changeForgottenPassword',
}
